export default "__VITE_ASSET__c3b73985__"